<template>
  <div class="distributor-box details_box_styles">
    <!--返回按钮-->
    <div class="go-back" style="display: inline-block" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <!--备货仓库-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1006410') }}</h2>
        </template>
        <div class="flex align-items-center">
          <span>{{ configCharacters() + $t('key1000333') }}</span>
          <Select v-model="ymsWarehouseId" transfer style="width: 200px;" @on-change="ymsWarehouseChange">
            <Option v-for="item in ymsWarehouseData" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
          </Select>
        </div>
      </Card>
    </div>
    <!--订单商品-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004421') }}</h2>
        </template>
        <div class="mb20">
          <Button type="primary" class="mr15" icon="md-add" :disabled="!ymsWarehouseId" @click="addProductBtn">{{ $t('key1001092') }}</Button>
          <Button icon="md-trash" :disabled="tableData.length<=0" @click="deleteProductBtn('all')">{{ $t('key1005966') }}</Button>
        </div>
        <Table
          ref="tableDom"
          :highlight-row="false"
          border
          max-height="400"
          :loading="tableLoading"
          :columns="tableColumns"
          :no-data-text="$t('key1005957')"
          :span-method="handleSpan"
          @on-selection-change="getSelectValue"
          :data="tableData">
        </Table>
        <div class="flex total_goods_box">
          <div>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1005969') }}</span>
              <span class="goods_num_style money_item_style">{{ totalQuantityGoods }}</span>
            </p>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1005970') }}</span>
              <span class="goods_num_style money_item_style">{{ totalWeight }}</span>
            </p>
          </div>
          <div>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1000119') }}</span>
              <span class="goods_num_style money_item_style">{{ currencyState + ' ' + totalAmountGoods }}</span>
            </p>
            <p class="mb10">
              <span class="money_item_style text-align-right">
                {{ $t('key1000120') }}
              </span>
              <span class="goods_num_style money_item_style"> - </span>
            </p>
          </div>
        </div>
      </Card>
    </div>
    <!--提交商品按钮操作栏-->
    <div class="submit_goods_box" :class="fixedTalg ? 'fixed_box_style': ''">
      <div class="flex flex-direction">
        <div class="flex align-items-center mb4">
          <span>{{ $t('key1001493') }}</span>
          <span class="goods_num_style" style="font-size: 18px;">{{ currencyState }} {{ totalPayable }}</span>
        </div>
        <Checkbox v-model="automaticPayment" :true-value="1" :false-value="0">{{ $t('key1006411') }}</Checkbox>
      </div>
      <Tooltip transfer placement="top-end" :offset="10" :max-width="450" :content="$t('key1005959')">
        <Icon type="ios-alert-outline" color="#FD5425" size="21" style="margin:0 0 0 8px; cursor: pointer;"/>
      </Tooltip>
      <Button size="large" class="mr15 ml30" @click="cancelOrderBtn">{{ $t('key1000112') }}</Button>
      <Button size="large" :disabled="placeOrderTalg || tableData.length<=0" type="primary" @click="placeOrderBtn">{{ $t('key1000367') }}</Button>
    </div>
    <div style="visibility: hidden" :class="fixedTalg ? 'fixed_style' : ''"></div>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      systemType="distributor"
      :distributorShowFieldKeyList="['selection', 'goodsInfo', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice']"
      @updateGoodsData="updateGoodsData">
    </addCommonProductModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal
      ref="orderSubmission"
      @errorOrderData="errorOrderData"
      @updateOrderData="updateOrderData">
    </orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import {amountHandel, commonLocalStorage, getDistributorWarehouseData, getTrialGoodsPrice, getTrialPrice, setConfigCharacters} from "@/utils/common";
import {getAppClientHeight, getAppScrollContainer, getAppScrollHeight, getAppScrollTop} from "@/utils/appScroll";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";

export default {
  name: "createBackupOrder",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      ItemCol: 8,
      placeOrderTalg: false,
      selectGoodsList: [],
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 300,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let imgPath = '';
            if (params.row._productInfo) {
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
              imgPath = skuImgPath ? skuImgPath : spuImgPath;
            }
            let list = [
              v.tableImg(h, params, 'primaryImage', imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 200,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let list = [];
            let ymsSku = params.row.ymsSku;
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            if (productGoodsSpecifications.length > 0) {
              list = productGoodsSpecifications.map((item) => {
                return item.value;
              });
            }
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, list.join(' • '))
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'),
          key: 'availableNumber',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let number = params.row.availableNumber || 0;
            return h('span', v.formatCurrency(number, 0));
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006407')}`,
          key: 'ymsAvailableNumber',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let number = params.row.ymsAvailableNumber || 0;
            return h('span', v.formatCurrency(number, 0));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001110'),
          key: 'suggestPrice',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let unitPrice = params.row.unitPrice || 0;
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, v.currencyState),
              h('div', v.formatCurrency(unitPrice)),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005944'),
          key: 'quantity',
          minWidth: 200,
          align: 'left',
          render: (h, params) => {
            let availableNumber = params.row.availableNumber || 0;
            let ymsAvailableNumber = params.row.ymsAvailableNumber || 0;
            let maxNumber = availableNumber + ymsAvailableNumber;
            return h('div', [
              h('InputNumber', {
                props: {
                  controlsOutside: true,
                  value: params.row.quantity ? params.row.quantity : null,
                  min: maxNumber <= 0 ? 0 : 1,
                  max: maxNumber,
                  /* activeChange: false,*/
                  formatter: value => `${parseInt(value)}`
                },
                style: {
                  width: '160px',
                  textAlign: 'left'
                },
                on: {
                  'on-change': num => {
                    if (num > 0) {
                      let weight = parseInt(num) * params.row.weight;
                      v.$set(v.tableData[params.index], 'commodityWeight', weight);
                      v.$set(v.tableData[params.index], 'quantity', parseInt(num));
                      setTimeout(() => {
                        v.getCommodityPrice(v.tableData, 'update');
                      }, 800);
                    }
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005945'),
          key: 'subtotal',
          minWidth: 110,
          align: 'left',
          render: (h, params) => {
            let subtotal = params.row.unitPrice * parseInt(params.row.quantity);
            let total = v.formatCurrency(subtotal);
            v.$set(v.tableData[params.index], 'subtotal', subtotal);
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, v.currencyState),
              h('div', total),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 120,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: true,
                    clickFn: () => {
                      v.deleteProductBtn('single', params.row.ymsSku);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      processingFee: 0, // 处理费
      totalPayable: 0, // 应付总额
      totalAmountGoods: 0, // 商品总金额
      totalWeight: 0, // 商品总重量
      totalQuantityGoods: 0, //商品的总数量
      fixedTalg: true,
      ymsWarehouseData: [],
      ymsWarehouseId: null,
      automaticPayment: 1, // 下单后自动付款
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  mounted() {
    getAppScrollContainer().addEventListener('scroll', this.scrollBottom);
  },
  created() {
    getDistributorWarehouseData(this.userInfo.merchantId).then((data) => {
      let newData = data || [];
      this.ymsWarehouseData = newData.filter((item) => {
        return item.servicePlatform === 'core' && item.stockedWarehouse === 1;
      });
    });
  },
  methods: {
    // 返回列表
    goBackBtn() {
      localStorage.removeItem('originalYmsWarehouseData');
      this.$router.push('/distributorStockList');
    },
    // 添加商品
    addProductBtn() {
      this.$refs['addCommonProduct'].initFun();
      this.$refs['addCommonProduct'].selectTableData = this.tableData;
    },
    // 删除商品
    deleteProductBtn(type, ymsSku) {
      let new_arr = [];
      // 批量删除，是按照spu维度删除
      if (type === 'all') {
        if (this.selectGoodsList.length > 0) {
          this.tableData.map((item, index) => {
            if (!this.selectGoodsList.includes(item.ymsSpu)) {
              new_arr.push(item);
            }
          });
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005948'));
          return false;
        }
        this.selectGoodsList = [];
      }
      // 单个删除，是按照sku维度删除
      else {
        if (this.tableData.length > 1) {
          new_arr = this.tableData.filter((item) => {
            return item.ymsSku !== ymsSku;
          });
        } else {
          this.tableData.map((item, index) => {
            if (item.ymsSku === ymsSku) {
              this.tableData.splice(index, 1);
            }
          });
        }
      }
      if (new_arr.length > 0) {
        this.updateGoodsData(new_arr);
      } else {
        this.tableData = [];
      }
    },
    // 勾选列表数据
    getSelectValue(value) {
      this.selectGoodsList = [];
      if (value) {
        value.map((item) => {
          this.selectGoodsList.push(item.ymsSpu);
        });
      }
    },
    // 处理选中的商品数据
    updateGoodsData(data) {
      if (data && data.length > 0) {
        const ymsProductGoodsIds = Array.from(new Set(data.map(item => item.ymsProductGoodsId).filter(Boolean)));
        if (ymsProductGoodsIds.length > 0) {
          let query = {
            ymsProductGoodsIds: ymsProductGoodsIds,
            ymsWarehouseId: this.ymsWarehouseId,
          };
          this.axios.post(api.post_ymsPlatformOrder_queryInventoryWarehouse, query).then(response => {
            if (response.data.code === 0) {
              let inventoryWarehouseData = response.data.datas || [];
              data.map(item => {
                inventoryWarehouseData.map((ele) => {
                  if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                    item.availableNumber = ele.availableNumber;
                    item.ymsAvailableNumber = ele.ymsAvailableNumber;
                    let number = ele.availableNumber + ele.ymsAvailableNumber;
                    item.quantity = number > 0 ? 1 : 0;
                  }
                });
              });
              const res = new Map();
              let listData = data.reduce((list, item) => {
                if (res.has(item.ymsSku)) {
                  res.get(item.ymsSku).quantity += item.quantity;
                } else {
                  let obj = {...item};
                  list.push(obj);
                  res.set(item.ymsSku, obj);
                }
                return list;
              }, []);
              listData.map((item) => {
                item['commodityWeight'] = item.weight * item.quantity;
              });
              this.handleTableData(listData);
            }
          });
        }
      }
    },
    // 处理列表数据,按照SPU维度合并行数据
    handleTableData(data) {
      let v = this;
      let newList = [];
      v.tableData = [];
      if (data.length > 0) {
        let newData = v.handerGrouping(data, function (item) {
          return [item.ymsSpu];
        }, 'ymsSpu', 'ymsSkuList');
        if (newData.length > 0) {
          newData.map((ele) => {
            let length = ele.ymsSkuList.length;
            ele.ymsSkuList.map((talg, index) => {
              talg['length'] = length;
              talg['currentTalg'] = (length > 1 && index === 0);
              newList.push(talg);
            });
          });
        }
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
          });
          setTimeout(() => {
            v.getCommodityPrice(newList, 'update');
          }, 800);
        }
      }
    },
    // 获取当前商品在指定仓库下的价格
    getCommodityPrice(productGoodsList, value) {
      const v = this;
      v.placeOrderTalg = true;
      return new Promise((resolve) => {
        let queryList = [];
        const handleData = (goodsList) => {
          if (value === 'update') {
            v.optionBtnWidth = [];
            v.tableData = goodsList;
            v.updateTableDom('tableDom');
            setTimeout(() => {
              v.updateTableDom('tableDom');
            }, 2000);
          }
          v.placeOrderTalg = false;
          resolve(goodsList);
        };
        if (v.ymsWarehouseId) {
          productGoodsList.map((item) => {
            item.ymsWarehouseId = v.ymsWarehouseId;
            let obj = {
              priceTrialGoodsBoList: [{
                quantity: item.quantity,
                ymsProductGoodsId: item.ymsProductGoodsId,
                isNeedCustomization: 0
              }],
              ymsDistributorMerchantId: v.userInfo.merchantId,
              warehouseIds: [v.ymsWarehouseId]
            };
            queryList.push(obj);
          });
          if (queryList.length > 0) {
            getTrialGoodsPrice({productGoodsList, queryList}).then((goodsList) => {
              handleData(goodsList);
            });
          } else {
            handleData(productGoodsList);
          }
        } else {
          handleData(productGoodsList);
        }
      });
    },
    // 取消订单
    cancelOrderBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005951'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005952'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005953'),
        onOk: () => {
          v.goBackBtn();
        },
        onCancel: () => {
        }
      });
    },
    // 提交订单
    placeOrderBtn() {
      let v = this;
      if (v.tableData.length <= 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005954'));
        return false;
      }
      if (!v.ymsWarehouseId) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006408'));
        return false;
      }
      let query = {
        stockPackageInfoVos: [
          {
            ymsPackageGoods: [],
            ymsWarehouseId: v.ymsWarehouseId
          }
        ]
      };
      v.tableData.map((item) => {
        query.stockPackageInfoVos[0].ymsPackageGoods.push({
          quantity: item.quantity,
          ymsSku: item.ymsSku
        });
      });
      if (v.automaticPayment === 1) {
        let obj = {
          totalPrice: Number(v.totalPayable),
          currency: v.currencyState,
          params: {
            url: api.post_ymsDistributorStockUpInfo_createStockOrder,
            query
          },
        }
        v.$refs['orderSubmission'].initOrderSubmissionData(obj)
      } else {
        query.payType = 0;
        handleData();
      }

      function handleData() {
        v.axios.post(api.post_ymsDistributorStockUpInfo_createStockOrder, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let payStatus = data[0].payStatus;
              let text = payStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : payStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006409') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155');
              v.$Message.success(text);
              v.goBackBtn();
            }
          } else {
            v.errorOrderData();
          }
        });
      }
    },
    // 下单失败，错误操作
    errorOrderData() {
      commonLocalStorage.setItem('originalYmsWarehouseData', this.ymsWarehouseData);
    },
    // 下单成功，更新操作
    updateOrderData(obj) {
      let {data} = obj;
      let payStatus = data[0].payStatus;
      let text = payStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : payStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005980') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155');
      this.$Message.success(text);
      this.goBackBtn();
    },
    // 全部移除商品时，重置数据
    resetData() {
      this.selectGoodsList = [];
      this.processingFee = 0;
      this.totalPayable = 0;
      this.totalAmountGoods = 0;
      this.totalWeight = 0;
      this.totalQuantityGoods = 0;
    },
    // 监听是否滚动到底部
    scrollBottom() {
      let talg = 200;
      let v = this;
      if (!v.fixedTalg) {
        v.fixedTalg = true;
      }
      let scrollContainer = getAppScrollContainer();
      let scrollTop = getAppScrollTop(scrollContainer);
      let clientHeight = getAppClientHeight(scrollContainer);
      let scrollHeight = getAppScrollHeight(scrollContainer);
      if (scrollTop + clientHeight >= scrollHeight - talg) {
        v.fixedTalg = false;
      }
    },
    // 处理侧边栏菜单留白的问题
    handerMenuStyle(value) {
      let v = this;
      v.$nextTick(() => {
        let dom = [...document.querySelectorAll("div[id='distributorSidebarBox']")];
        if (dom && dom.length > 0) {
          dom[0].style.height = value ? 'initial' : '100vh';
        }
      });
    },
    // 获取试算价格
    setPrice() {
      let v = this;
      v.placeOrderTalg = true;
      let priceTrialGoodsBoList = v.tableData.map(i => {
        return {
          quantity: i.quantity,
          ymsProductGoodsId: i.ymsProductGoodsId,
          isNeedCustomization: 0
        };
      });
      let query = {
        priceTrialGoodsBoList: priceTrialGoodsBoList,
        shippingMethodId: null,
        ymsDistributorMerchantId: v.userInfo.merchantId,
        warehouseIds: [v.ymsWarehouseId]
      };
      getTrialPrice(query).then((newData) => {
        v.placeOrderTalg = false;
        if (newData.length > 0) {
          newData.map((ele) => {
            if (v.ymsWarehouseId === ele.warehouseId) {
              v.totalAmountGoods = amountHandel(ele.goodsPrice);
              v.processingFee = amountHandel(ele.handlePrice);
              v.totalPayable = amountHandel(ele.totalPrice - ele.handlePrice);
            }
          });
          v.$forceUpdate();
        }
      });
    },
    // 切换yms仓库
    ymsWarehouseChange(value) {
      let v = this;
      if (v.tableData.length > 0) {
        setTimeout(() => {
          v.ymsWarehouseId = value;
          v.updateGoodsData(v.tableData);
        }, 1000);
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['skuInfo', 'availableNumber', 'ymsAvailableNumber', 'suggestPrice', 'quantity', 'subtotal', 'options'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
  },
  //页面离开后销毁监听事件
  destroyed() {
    this.handerMenuStyle(false);
    getAppScrollContainer().removeEventListener('scroll', this.scrollBottom);
  },
  watch: {
    // 监听商品数据
    tableData: {
      handler(data) {
        let v = this;
        if (data.length > 0) {
          // 商品的总重量
          v.totalWeight = data.reduce(
            (pre, cur) => {
              return pre + cur.commodityWeight;
            }, 0);

          // 商品总数量
          v.totalQuantityGoods = data.reduce(
            (pre, cur) => {
              return pre + cur.quantity;
            }, 0);
          setTimeout(() => {
            v.setPrice();
          }, 1500);
        } else {
          v.resetData();
        }
      },
      deep: true
    }
  },
  components: {
    orderSubmissionModal,
    addCommonProductModal,
  }
};
</script>

<style lang="less" scoped>
.details_box_styles {
  .total_goods_box {
    margin: 30px 115px 20px 0;
    justify-content: flex-end;
  }

  .money_item_style {
    display: inline-block;
    min-width: 120px;
  }

  .goods_num_style {
    color: #FD5425;
    font-weight: bold;
    font-size: 14px;
    min-width: 94px;
  }

  .submit_goods_box {
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 90px 10px 0;
    margin-bottom: 12px;
  }

  .fixed_box_style {
    position: fixed;
    z-index: 1000;
    left: 0;
    bottom: 0;
    margin-bottom: 0;
    box-shadow: 0px -3px 10px 0px #c9cbce;
  }

  .fixed_style {
    height: 60px;
    margin-bottom: 12px;
  }

  /deep/ .ivu-input-number-input {
    text-align: center;
  }

  /deep/ .ivu-input-number-controls-outside-btn-disabled {
    background-color: #f3f3f3 !important;

    i {
      color: #ccc !important;
    }
  }
}
</style>
